module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments.htm#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_01.htm#part1"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PART ONE")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("COLONIAL CLASHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_01.htm#chap1"
    }
  }, [_vm._v("1. “Una Casa, Dos Mujeres”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_02.htm#chap2"
    }
  }, [_vm._v("2. “Poligamie/Nintiouiouesaïn”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_03.htm#chap3"
    }
  }, [_vm._v("3. “Christians Have Kept 3 Wives”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_04.htm#chap4"
    }
  }, [_vm._v("4. “Negroe Mens Wifes”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_02.htm#part2"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PART TWO")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("ENLIGHTENED ENCOUNTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_05.htm#chap5"
    }
  }, [_vm._v("5. “The Natural Violence of Our Passions”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_06.htm#chap6"
    }
  }, [_vm._v("6. “Such a Revolution as This”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_07.htm#chap7"
    }
  }, [_vm._v("7. “The Repugnance Inherent in Having Multiple Wives”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_08.htm#chap8"
    }
  }, [_vm._v("8. “Defence of Polygamy by a Lady”")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/conclusion.htm#conclu"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0